<template>
	<span class="task-head" :style="headStyle">
		<icon-button :name="node.icon" @click="openTask"></icon-button>
		<label class="task-check-label">
			<input type="checkbox" class="task-check" v-model="node.completed" :disabled="!!readonly">
			<span class="task-label">
				<a href="#" :class="{ 'project-label':project, 'project-modified':modified }" @click.prevent="openTask">{{ node.name }}</a>
				<icon-button v-if="canNavigate" name="open" class="task-label-link" @click.prevent="navigateTask"></icon-button>
			</span>
		</label>
	</span>
</template>

<script setup lang="ts">
import {ref, computed, type CSSProperties} from "vue";
import SymIcon from "@fd/helpers/SymIcon.vue";
import {UnifiedProjectNode} from "@fd/containers/subtasks/NodeUtils.ts";
import IconButton from "@fd/helpers/IconButton.vue";

const props = defineProps<{
	node: UnifiedProjectNode,
	level: number,
	project?: boolean,
	/** Global form readonly flag */
	readonly?: boolean,
	modified?: boolean
}>();

const emit = defineEmits(["open", "navigate"]);

const canNavigate = computed(() => !!props.node.id);
const headStyle = computed<CSSProperties>(() => {
	const s: CSSProperties = {};
	if (props.level > 0) s.paddingLeft = props.level * 26 + "px";
	return s;
});

function openTask() {
	emit("open", props.node._type, props.node.id);
}

function navigateTask() {
	emit("navigate", props.node._type, props.node.id);
}

</script>

<style>
.task-head {
	display: flex;
	flex-direction: row;
	align-items: baseline;
	column-gap: 8px;

	& > .fi {
		width: 18px;
		min-width: 18px;
		text-align: center;
	}
}
.project-label {
	font-weight: 500;
}
.project-modified {
	font-style: italic;
}

.task-check-label {
	display: flex;
	flex-direction: row;
	align-items: baseline;
	column-gap: 6px;
}
.task-label {
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	align-items: baseline;
	column-gap: 2px;
}

@media (hover: hover) {
	.task-label {
		.task-label-link {
			opacity:0;
			transition: opacity 500ms;
		}

		&:hover {
			.task-label-link {
				opacity:1;
			}
		}
	}
}
</style>